import { render, staticRenderFns } from "./TeamsPanel.vue?vue&type=template&id=b76be3ce&"
import script from "./TeamsPanel.vue?vue&type=script&lang=js&"
export * from "./TeamsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports